import { PencilIcon, TrashIcon } from '@heroicons/react/20/solid'

import FilterableCell, { getRefId } from '@/widgets/FilterableCell'

export default function TypyPlacowekTableRow({ typPlacowki, onEdit, onDelete, onTypClick }) {
	const typId = getRefId(typPlacowki)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={typId}
					label={typPlacowki?.typ || '-'}
					onFilter={onTypClick}
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
				<div className="inline-flex items-center gap-2">
					<button
						type="button"
						onClick={() => onEdit(typPlacowki)}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100">
						<PencilIcon className="h-4 w-4" />
						<span>Edytuj</span>
					</button>
					<button
						type="button"
						onClick={() => onDelete(typPlacowki)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100">
						<TrashIcon className="h-4 w-4" />
						<span>Usuń</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
